import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AiTwotoneHeart } from 'react-icons/ai'
import { GiSeaStar } from 'react-icons/gi'
import { Url } from '../../UrlServer'
import { Product } from '../../../redux/reducers/productReducers'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { fetchProductsAPI } from '../../../redux/actions/productActions'

interface ProductsRecommendProps {
  productID: string
  categoryID: string
}

const ProductsRecommend: React.FC<ProductsRecommendProps> = ({
  productID,
  categoryID
}) => {
  const dispatch = useAppDispatch()
  const [recommend, setRecommend] = useState<Product[]>([])
  const { products } = useAppSelector((state: RootState) => state.products)
  // const { products } = useContext(Ctx);

  useEffect(() => {
    const fetchCate = () => {
      const cateArr = products.filter(
        arr => arr.category._id === categoryID && arr._id !== productID
      )
      return setRecommend(cateArr)
    }
    fetchCate()
  }, [products, productID])
  useEffect(() => {
    dispatch(fetchProductsAPI())
  }, [dispatch])

  return (
    <div className="products-recommend">
      <div className="prd">
        <div className="product-s">
          {recommend
            ? recommend.map(product => {
              const str = product.description
              return (
                <Link
                  to={`/details/${product._id}`}
                  className="prdBx"
                  key={product._id}
                >
                  <AiTwotoneHeart className="editPrd" />
                  <div className="img-wraper">
                    <img src={`${Url}/${product.image}`} alt="" />
                  </div>
                  <h2>{product.name}</h2>
                  <span> {product.category.name}</span>
                  <div className="rating">
                    <GiSeaStar />
                    <GiSeaStar />
                    <GiSeaStar />
                    <GiSeaStar />
                    <GiSeaStar />
                  </div>
                  <div className="prdDecription">
                    {str.length < 17 ? str : str.slice(0, 90) + '...'}
                  </div>
                  <div className="prdBot">
                    <span className="prdPrice">{product.price} $</span>
                    <button>View</button>
                  </div>
                </Link>
              )
            })
            : 'product not found'}
        </div>
      </div>
    </div>
  )
}

export default ProductsRecommend
